"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const style = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
};
const statStyle = {
    display: 'flex',
    flexDirection: 'column',
};
const StatDetail = ({ device, name, onClick, value }) => (React.createElement("div", { style: Object.assign(Object.assign({}, style), { width: device === 'Mobile' ? '100%' : 362 }), onClick: () => onClick() },
    React.createElement("div", { style: statStyle },
        React.createElement(src_1.Text, { label: true, size: "small", text: name, textStyle: { color: src_1.steel } }),
        React.createElement(src_1.Text, { size: "medium", text: value })),
    React.createElement(src_1.ChevronRightIcon, { fill: src_1.titanium })));
exports.default = StatDetail;
